import JobPositionDetailsTemplate from "../../templates/JobPositionDetailsTemplate/JobPositionDetailsTemplate";
import useFetch from "../../../hooks/useFetch";
import { jobPositionsRepository } from "../../../repository/jobPositions.repository";
import { useContext, useEffect } from "react";
import { Loader } from "../../atoms/Loader/Loader";
import { useDocumentTitleLoading } from "../../../hooks/useDocumentTitle";
import { PostContext } from "../../../contexts/PostContext";

const JobPositionDetails = ({ match }) => {
  const { data, fetchData, resetData } = useFetch();
  const { isResponseOk } = useContext(PostContext);

  useDocumentTitleLoading();

  useEffect(() => {
    if (isResponseOk || !data) {
      fetchData(jobPositionsRepository.getJobPositionDetails(match.params.id));
    }
  }, [isResponseOk]);

  // Handle picking search result
  useEffect(() => {
    if (data) {
      resetData();
      fetchData(jobPositionsRepository.getJobPositionDetails(match.params.id));
    }
  }, [match.params.id]);

  return data ? (
    <JobPositionDetailsTemplate data={data} />
  ) : (
    <Loader />
  );
};

export default JobPositionDetails;
